import { render, staticRenderFns } from "./RelatedWork.vue?vue&type=template&id=ab468a5e&scoped=true&"
import script from "./RelatedWork.vue?vue&type=script&lang=js&"
export * from "./RelatedWork.vue?vue&type=script&lang=js&"
import style0 from "./RelatedWork.vue?vue&type=style&index=0&id=ab468a5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab468a5e",
  null
  
)

export default component.exports